
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives/[platform]",
      function () {
        return require("private-next-pages/alternatives/[platform]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives/[platform]"])
      });
    }
  